<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="500px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <span class="edit-button" slot="activator">edit</span>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid" ref="clientDetailForm">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Edit client details</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
              <span class="done-button" @click="onSaveChanges" v-if='valid'>done</span>
              <span class="done-button disabled" v-if='!valid'>done</span>
          </v-flex>
        </v-layout>
        <v-layout row v-if="invoice.status === 'Sent'">
          <v-flex xs12>
            <v-alert color="warning" icon="info" value="true">
              This invoice has been Sent.
            </v-alert>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex >
              <v-text-field
              name="hideauto-search-contact"
              label="Contact"
              placeholder=" "
              v-model="contact"
              type="search"
              ></v-text-field>
            <v-text-field
              name="hideauto-search-name"
              label="Client name"
              v-model="name"
              :rules="[input_required]"
              type="search"
              placeholder=" "
              ref="focus"
              autofocus
              autocomplete="false"
              ></v-text-field>
              <v-text-field
              name="hideauto-search-address"
              label="Address"
              v-model="address"
              type="search"
              placeholder=" "
              autocomplete="false"
              ></v-text-field>
              <v-text-field
              name="hideauto-search-address2"
              label="Address 2"
              v-model="address2"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-town"
              label="Town"
              v-model="town"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-county"
              label="County"
              v-model="county"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-country"
              label="Country"
              v-model="country"
              type="search"
              placeholder=" "
              ></v-text-field>
              <v-text-field
              name="hideauto-search-postCode"
              label="Postcode"
              v-model="postCode"
              placeholder=" "
              type="search"
              ></v-text-field>
              <v-combobox
              name="hideauto-search-emails"
              v-model="emails"
              label="Email addresses"
              multiple
              chips
              :rules="[emailRules]"
              placeholder=" "
              deletable-chips
              ref="clientEmails"
              validate-on-blur
              :delimiters="[',', ';', ' ']"
              @change="$refs.clientDetailForm.validate();"
            ></v-combobox>
          </v-flex>
          <v-flex pt-0 mt-0>
            <v-checkbox
              color="primary"
              label="Save as the client's default address details"
              v-model="saveAsDefault"
              ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  name: 'EditClientDetailsModal',
  props: {
    invoice: Object,
    client: Object
  },
  data () {
    return {
      valid: false,
      showDialog: false,
      saveAsDefault: true,
      name: this.invoice.clientName,
      contact: this.invoice.contact || '',
      address: this.invoice.clientAddress || '',
      address2: this.invoice.clientAddress2 || '',
      town: this.invoice.clientTown || '',
      county: this.invoice.clientCounty || '',
      country: this.invoice.clientCountry || '',
      postCode: this.invoice.postCode || '',
      groupId: this.$store.getters.user.group,
      clients: this.$store.getters.clients,
      emails: this.client.emails || [],
      input_required: value => !!value || 'Required.',
      emailRules:
        v => {
          if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
              if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Enter one or more valid emails'
              }
            }
            return true
          } else {
            return false
          }
        }
    }
  },
  watch: {
    showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    async onSaveChanges () {
      // blur the email field to trigger the validation and set it in place, without this emails entered right before
      // the save button is clicked are not saved
      this.$refs.clientEmails.blur()
      // wait for the next tick to ensure the emails are set
      this.$nextTick(async () => {
        if (this.name.trim() === '') {
          return
        }
        this.$emit('return-client-details', {
          clientName: this.name,
          contact: this.contact,
          clientAddress: this.address,
          clientAddress2: this.address2,
          clientTown: this.town,
          clientCounty: this.county,
          clientCountry: this.country,
          postCode: this.postCode,
          emails: this.emails
        })
        // TODO shift clients to using id keys instead of matching name incase user wants to change the name
        // If user wants to make address the new default...
        if (this.saveAsDefault === true) {
          // find the client's id by name using array.find
          const matchedClient = this.clients.find(obj => obj.name === this.invoice.clientName)

          // if there is an existing client then update it, if not create it
          if (!matchedClient) {
            await this.$store.dispatch('createClient', {
              name: this.name,
              contact: this.contact,
              address: this.address,
              address2: this.address2,
              town: this.town,
              county: this.county,
              country: this.country,
              postCode: this.postCode,
              emails: this.emails
            })
          } else {
            const clientId = matchedClient.id
            // build the update object
            const clientUpdate = {
              name: this.name,
              contact: this.contact,
              address: this.address,
              address2: this.address2,
              town: this.town,
              county: this.county,
              country: this.country,
              postCode: this.postCode,
              emails: this.emails
            }

            // save object to FB using the client'd id
            firebase.database().ref(`clients/${this.groupId}/${clientId}`).update(clientUpdate)
              .then(() => {
                this.$store.commit('setLoading', false)
              })
              .catch(error => {
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)
              })
          }
        }
        this.toggleDialog()
      })
    },
    toggleDialog () {
      this.showDialog = !this.showDialog
    }
  }

}
</script>
